<template>
    <div class="signBox">
        <div class="imgBox">
            <div class="bannerBox">
                <div class="titleBox">
                    <img src="../assets/images/LOGOs.png" alt="" style="height:43px">
                    <p>生物医疗销售全流程管理系统&nbsp;&nbsp; |&nbsp;&nbsp; 密码重置</p>
                </div>
                <div class="whiteBox">
                    <div class="titles">密码重置</div>
                    <div v-if="indx==0" class="checkingBox">
                        <div class="checking">
                            <div class="formBox">
                                <el-form :inline="true" :rules="rules" ref="form" :model="form" class="demo-form-inline h-formBorder h-formBorder-4">
                                    <!--<el-form-item class="h-elformWrap-5" label="用户" prop="phone">
                                        <el-input v-model="phoneForm.phone" placeholder="请输入手机号码"></el-input>
                                    </el-form-item>-->
                                    <div class="titles">
                                        <h3>密码复杂度规范：</h3>
                                        <h6>1、新密码长度不能小于10位；</h6>
                                        <h6>2、必须包含大写字母、小写字母、数字和特殊符号中的三项，且无键盘连续字母、字符、数字；</h6>
                                        <h6>3、不能包含用户的账户名 例如：张三、zhangsan；</h6>
                                        <h6>4、不能包含应用名称 例如：iHaier、portal；</h6>
                                        <h6>5、不能包含公司名称和业务关键字，例如：haier、cosmoplat、rrswl；</h6>
                                        <h6>6、不能包含超过3位的连续数字、连续字母、重复数字或重复字母，例如：1234、abcd、1111、aaaa；</h6>
                                    </div>
                                    <div class="mima">
                                        用户：{{username}}
                                    </div>
                                    <el-form-item class="h-elformWrap-5" label="新密码" prop="pass">
                                        <el-input type="password" v-model="form.pass" placeholder="输入新密码，密码必须包含大写字母、小写字母、数字其中的两种"></el-input>
                                    </el-form-item>
                                    <!-- <div class="mimaBox">
                                        <div class="mima">
                                            <div class="mimaY" :class="{'active':mimaI==index}" v-for="(item,index) in mimaList" :key="index"></div>
                                        </div>
                                    </div> -->
                                    <el-form-item class="h-elformWrap-5" label="确认新密码" prop="repass">
                                        <el-input type="password" v-model="form.repass" placeholder="再一次输入新密码"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="jieshouBox" style="margin-top:57px;" @click="updateUserPass">
                                提交
                            </div>
                        </div>
                    </div>
                    <div v-if="indx==1" class="checkingBox">
                        {{msg}}
						<div v-if="show" style="margin-top: 20px; font-size: 18px;">将在<span style="font-size: 20px;color: #ff2424;">{{count}}秒</span>后跳转至登录页</div>
                    </div>
                </div>
            </div>
            <div class="bottoms">
                Copyright Haier 2019. All rights reserved
            </div>
        </div>
    </div>
</template>
<script>
	import ss from '../api/SystemService'
	import store from "../store";
import dragVerify from 'vue-drag-verify'

function checkPassword(pwd) {
    var len = pwd.length;
    var flag = true;
    for (var i = 1; i < len-3; i++) {
        var firstIndex = pwd.charCodeAt(i-1);
        var secondIndex = pwd.charCodeAt(i);
        var thirdIndex = pwd.charCodeAt(i+1);
        var fourthIndex = pwd.charCodeAt(i+2);

        if((fourthIndex - thirdIndex == 1)&&(thirdIndex - secondIndex == 1)&&(secondIndex - firstIndex==1)){
            flag =  false;
        }
    }
    return flag;

}

function validateKey(str) {
    //定义横向穷举
    var keyCode = [
        ["`~·", "1=", "2@@", "3#", "4$￥", "5%", "6^……", "7&", "8*", "9(（", "0）)", "-_", "=+"],
        [" ","qQ", "wW", "eE", "rR", "tT", "yY", "uU", "iI", "oO", "pP", "[{【", "]}】", "\\|、"],
        [" ","aA", "sS", "dD", "fF", "gG", "hH", "jJ", "kK", "lL", ";:", "\'\"’“"],
        [" ","zZ", "xX", "cC", "vV", "bB", "nN", "mM", ",《<", ".>》", "/?？"]
    ];

    //找出给出的字符串，每个字符，在坐标系中的位置。
    var c = str.split("");
    var x = new Array();
    var y = new Array();
    for (var i = 0; i < c.length; i++) {
        var temp = c[i];
        toHere:
            for (var j = 0; j < keyCode.length; j++) {
                for (var k = 0; k < keyCode[j].length; k++) {
                    var jk = keyCode[j][k];
                    if (jk.indexOf(temp)!=-1) {
                        x.push(j);
                        y.push(k);
                        break toHere;
                    }
                }
            }
    }
    var flag = false;
    for (var i = 0; i < x.length - 2; i++) {
        // 如果X一致，那么就是在一排
        if (x[i] == x[i + 1] && x[i + 1] == x[i + 2]) {//四者在同一行上
            if (y[i] > y[i + 2]) {
                if (y[i] - 1 == y[i + 1] && y[i] - 2 == y[i + 2]) {
                    flag = true;
                    break;
                }
            } else {
                if (y[i] + 1 == y[i + 1] && y[i] + 2 == y[i + 2]) {
                    flag = true;
                    break;
                }
            }
        } else if (x[i] != x[i + 1]
            && x[i + 1] != x[i + 2]
            && x[i] != x[i + 2]
        ) {//四者均不在同一行上,但是如果y相同，说明是一列
            if (y[i] == y[i + 1] && y[i + 1] == y[i + 2]) {
                flag = true;
                break;
            }
        }
    }
    return flag;
}

export default {
    data(){
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入新密码'));
            } else if (value !== this.form.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        var validatePassword = (rule, value, callback) => {
            //var reg1 = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*.])[\da-zA-Z~!@#$%^&*.]{10,}$/;//密码必须是8位以上、必须含有字母、数字、特殊符号
            var reg1 = /((^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])[\da-zA-Z_\W]{10,}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9])[\da-zA-Z_\W]{10,}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[^A-Za-z0-9])[\da-zA-Z_\W]{10,}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z_\W]{10,}$))/;
            var reg2 = /([a-zA-Z0-9])\1{3}/;
            var reg3 = /(iHaier|portal)/;
            if (!reg1.test(value)) {
                callback(new Error("密码必须是10位以上,必须含有大写字母、小写字母、数字、特殊符号中的三项"));
            } else if (reg2.test(value)) {
                callback(new Error("不能包含超过3位的重复数字或字母"));
            } else if (!checkPassword(value)) {
                callback(new Error("不能包含超过3位的连续数字或字母"));
            } else if (validateKey(value)){
                callback(new Error("不能包含键盘连续的字母,符号和数字"));
            } else if (reg3.test(value)){
                callback(new Error("不能包含应用名称"));
            } else {
                callback();
            }
        };
        return{
			count:3,
			show:false,
            indx:0,
            id:'',
            ucode:'',
            username:'',
            msg:'',
            form:{
                pass:'',
                repass:''
            },
            rules:{
                pass: [{trigger: "blur", validator: validatePassword}],
                    //{pattern: /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S+$/, message: '密码必须包含大写字母、小写字母、数字其中的两种！'}],
                repass: [{ validator: validatePass, trigger: 'blur' }],
            },
            mimaList:[1,2,3],
            mimaI:null,
        }

    },
    components:{
        dragVerify
    },
    methods:{
		 //3秒后进入跳转页面
		threeGo(){
			console.log(1)
			const TIME_COUNT = 3;
			if(!this.timer){
				this.count = TIME_COUNT;
				this.show = true;
				this.timer = setInterval(()=>{
				if(this.count > 0 && this.count <= TIME_COUNT){
					this.count--;
				}else{
					clearInterval(this.timer);
					this.timer = null;
					this.show = false;
					// //跳转的页面写在此处
					this.$router.push('login');
				}
			  },1000)
			}
		},
        updateUserPass() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.id = this.$route.query.id;
                    this.ucode = this.$route.query.ucode;
                    if (this.form.pass != null) {
                        ss.ResetPassService.updateUserPass(this.id,this.ucode,this.form.pass).then(rd => {
                            if(rd.f){
                                this.$msg.msgs(rd.msg)
                                this.indx=1;
                                this.msg=rd.msg;
								this.show = true;
								this.threeGo()
                            }else{
                                this.$msg.msge(rd.msg)
								
                            }
                        })
                    }
                } else {
                    this.$msg.msge("请完善信息后再提交！");
                    return false;
                }
            });
        },
        returnTable(){
            this.$router.go(-1)
        },
        tijiao() {
            // console.log(1)
            this.$refs.emailForm.validate((valid) => {
                if (valid) {
                    console.log('通过');
                } else {
                    this.$msg.msge("请完善信息后再提交！");
                    return false;
                }
            });

            this.showHidden = true;
        },
        submitUpload(){
            if(!this.canClick) return
            this.canClick  = false;
            this.content = this.totalTime +"s秒后重新发送"
            let clock = window.setInterval(() => {
            this.totalTime--
            this.content = this.totalTime + 's后重新发送'
            if (this.totalTime < 0) {
                window.clearInterval(clock)
                this.content = '重新发送验证码'
                this.totalTime = 10
                this.canClick = true  //这里重新开启
            }
            },1000)
        }
    },
    created(){
        this.id = this.$route.query.id;
        this.ucode = this.$route.query.ucode;

        ss.ResetPassService.checkResetpassUrl(this.id,this.ucode).then(rd=>{
            // console.log(rd);
            if(rd.f){
                this.username=rd.obj;
            }else{
                this.$msg.msge(rd.msg);
                this.indx=1;
                this.msg=rd.msg;
            }
        })
    }
}
</script>
<style scoped>
.checkingBox .checking .formBox .disabled{
 background-color: #999;
 border-color: #dcdcdc;
 color:#ccc;
 cursor: not-allowed; 
}
.imgBox{
    width: 100%;
    height: 695px;
    background: url(../assets/images/signBJ.jpg) center/cover;
}
.bannerBox{
    width: 1041px;
    margin: 0 auto;
}
.titleBox{
    padding-top: 147px;
    display: flex;
}
.titleBox p{
    font-size: 30px;
    color: #ffffff;
    padding: 0;
    margin: 0;
    line-height: 50px;
    margin-left: 38px;
}
.titles{
    font-size: 18px;
	color: #0e75e9;
    position: relative;
    padding-left: 9px;
    border-left: 5px solid #0e75e9;
}
.whiteBox{
    width: 100%;
    margin-top: 30px;
    padding: 50px 44px;
    background-color: #ffffff;
	border-radius: 8px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.07);
    margin-bottom: 73px;
}

.buttonBox{
    display: flex;
    align-items: center;
    margin-top: 40px;
}
.buttonBox .selebutton{
    width: 133px;
	height: 46px;
	border-radius: 4px;
	border: solid 2px #d2d2d2;
    text-align: center;
    line-height: 44px;
    margin-left: 26px;
    cursor: pointer;
    color: #9a9a9a;
}
.buttonBox .selebutton.active{
    background-color: #0370ff;
    border-color: #0370ff;
    color: #fff;
}
.checkingBox{
    padding: 0 44px 0 174px;
    margin-top: 70px;
	font-size: 18px;
}
.checkingBox .checking{
    width: 100%;
}
.bottoms{
    background: #000;
    width: 100%;
    height: 53px;
    text-align: center;
    line-height: 53px;
    font-size: 14px;
    color: #a4a4a4;
	position: fixed;
	bottom: 0;
	left: 0;
}
.sendBox{
    width: 70%;
    text-align: center;
    font-size: 18px;
    color: #848484;
    line-height: 30px;
    margin-top: 45px;
}
.sendBoxs{
    width: 60%;
    margin-left: 10%;
    text-align: center;
    font-size: 16px;
    color: #848484;
    line-height: 30px;
    margin-bottom: 100px;
}
.jieshouBox{
    width: 50%;
    margin: 140px auto 28px auto;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    background: #1b78e6;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 14%;
}
.mimaBox{
    width: 70%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0.8rem;
}
.mimaBox .mima{
    display: flex;
    justify-content: center;
}
.mimaBox .mima .mimaY{
    width: 67px;
	height: 7px;
	background-color: #d2d2d2;
	border-radius: 4px;
    margin-right: 5px;
}
.mimaBox .mima .mimaY:last-child{
    margin-right: 0;
}
.mimaBox .mima .mimaY.active{
    background-color: #ffcb2c;
}
.formBox .active{
    color:   red;
}
.redText{
    font-size: 14px;
    color:   #d1d1d1;
    margin-bottom: 10px;
}
</style>
<style>
.el-form-item.h-elformWrap-5{
    width: 100%;
}
.el-form-item.h-elformWrap-5 .el-form-item__content{
    display: flex;
    width: 100%;
}
.el-form-item.h-elformWrap-5 .el-form-item__content .el-input{
    width: 70%;
    height: 50px;
}
.el-form-item.h-elformWrap-5 .el-form-item__content .el-input .el-input__inner{
    height: 50px;
}
.el-form-item.h-elformWrap-5 .el-form-item__content .el-button--default{
    margin-left: 5%;
    width: 20%;
    background: #2686e7;
    color: #fff;
    font-size: 18px;
}

</style>
